__turbopack_context__.v({
  "grid": "DuoContent-module-scss-module__pKZL6W__grid",
  "left": "DuoContent-module-scss-module__pKZL6W__left",
  "right": "DuoContent-module-scss-module__pKZL6W__right",
});
